export const LIST_COLLECTIONS = 'collection.LIST_COLLECTIONS'
export const SET_COLLECTIONS = 'collection.SET_COLLECTIONS'
export const CLEAR_COLLECTIONS = 'collection.CLEAR_COLLECTIONS'

export const listCollections = (params, callback) => ({
  type: LIST_COLLECTIONS,
  params,
  callback,
})

export const setCollections = (data) => ({
  type: SET_COLLECTIONS,
  data,
})

export const clearCollections = () => ({
  type: CLEAR_COLLECTIONS,
})
